/*
 * Copyright (c) 2021. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import { SubExpenseViewModel } from 'src/types/view-models/sub-expense.view.model';
import { TimePeriod } from 'src/types/time-period';
import Anchor from '../atomic/atoms/anchor/Anchor';

// styles
import styles from './SubExpense.module.scss';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Selectors from 'src/utils/selectors';

export class SubExpense extends Component<SubExpenseViewModel> {
    public override render(): ReactComponentElement<any> {
        const className: JSX.Element =
            this.props.period !== TimePeriod.FUTURE ? (
                <Anchor
                    onClick={() => {
                        this.props.onClick();
                    }}
                    data-cy={Selectors.PlanAhead.SUB_EXPENSE_TITLE}
                    typographyProps={{
                        className: styles.nameBlue,
                        variant: TypographyVariants.SUBTEXT
                    }}
                >
                    {this.props.name}
                </Anchor>
            ) : (
                <Typography
                    className={styles.nameDefault}
                    variant={TypographyVariants.SUBTEXT}
                    data-cy={Selectors.PlanAhead.SUB_EXPENSE_TITLE}
                >
                    {this.props.name}
                </Typography>
            );

        return (
            <div className={styles.subExpense} data-cy={Selectors.PlanAhead.SUB_EXPENSE}>
                <div className={styles.subExpenseContainer}>
                    <div className={styles.left}>{className}</div>
                    <div className={styles.right}>
                        <Typography variant={TypographyVariants.SUBTEXT}>{this.props.value}</Typography>
                        <Typography variant={TypographyVariants.SUBTEXT}>{this.props.percentage}</Typography>
                    </div>
                </div>
                {this.props.children}
            </div>
        );
    }
}
